<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as OFFICE_TYPES } from './store'
import { ROUTES as OFFICE_ROUTES } from './router'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxListMixin from '../../../components/thux-list/ThuxListMixin'

import OfficeTable from './OfficeTable'
import OfficeCommonFilters from './OfficeCommonFilters'
import OfficeEdit from './OfficeEdit.vue'

export default {
  name: 'OfficeList',
  mixins: [ThuxListMixin],
  components: {
    'component-table': OfficeTable,
    'common-filters': OfficeCommonFilters,
    'component-edit': OfficeEdit
  },
  data () {
    return {
      OFFICE_ROUTES,
      title: this.$t('Offices'),
      rolePerm: ['office_office_list'],
      actionEnablePermission: ['office_office_enable'],
      actionDisablePermission: ['office_office_disable'],
      searchFields: [
        { key: 'filter__code__icontains', placeholder: this.$t('Code'), type: 'text', col: 4 },
        { key: 'filter__name__icontains', placeholder: this.$t('Name'), type: 'text', col: 4 },
        { key: 'filter__description__icontains', placeholder: this.$t('Description'), type: 'text', col: 4 },
        { key: 'filter__phone__icontains', placeholder: this.$t('Phone'), type: 'text', col: 4 },
        { key: 'filter__fax__icontains', placeholder: this.$t('Fax'), type: 'text', col: 4 },
        { key: 'filter__email__icontains', placeholder: this.$t('Email'), type: 'text', col: 4 }
      ]
    }
  },
  computed: {
    ...mapGetters({
      ...OFFICE_TYPES.GENERIC.office.office.LIST.GETTERS
    }),
    showList () {
      return this.$route.name === this.OFFICE_ROUTES.OFFICE_LIST
    },
    canSeeActionSelect () {
      return true
    },
    canAddInstance () {
      return hasPerm('office_office_create')
    }
  },
  methods: {
    ...mapMutations({
      setSelectedList: OFFICE_TYPES.GENERIC.office.office.LIST.MUTATIONS.setSelectedList,
      setSelectAll: OFFICE_TYPES.GENERIC.office.office.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...OFFICE_TYPES.GENERIC.office.office.LIST.ACTIONS
    })
  }
}
</script>
